export const RESPONSE_ERROR = 'modalRentError';
export const RESPONSE_PENDING = 'modalRentPending';
